// extracted by mini-css-extract-plugin
module.exports = {"GenericBadgeTags":"GenericBadgeTags_GenericBadgeTags__fkWFD","remainingTagsLink":"GenericBadgeTags_remainingTagsLink__CHPjG"};